import { Helmet } from 'react-helmet-async'
import VpnGatewayCalc from '../components/calculators/VpnGatewayCalc'
import { generateBreadcrumbList } from '../utils/schemaHelpers'
import { Breadcrumbs } from '../components/shared/Breadcrumbs'

export default function VpnGatewayPage() {
  return (
    <div className="px-6 py-6 w-full">
      <Helmet>
        <title>Azure VPN Gateway Calculator UK | AzureCalc.uk</title>
        <meta name="description" content="Calculate Azure VPN Gateway costs for UK South. Compare Basic, VpnGw1–5, and zone-redundant AZ SKUs in GBP. Updated from Azure Retail Prices API." />
        <link rel="canonical" href="https://www.azure-calc.co.uk/vpn-gateway" />
        <meta property="og:title" content="Azure VPN Gateway Calculator UK" />
        <meta property="og:description" content="Free independent Azure VPN Gateway pricing for UK South. All SKUs including zone-redundant AZ variants in GBP." />
        <meta property="og:url" content="https://www.azure-calc.co.uk/vpn-gateway" />
        <meta property="og:image" content="https://www.azure-calc.co.uk/og/azure-calc-og.png" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <script type="application/ld+json">{JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'HowTo',
          name: 'How to estimate Azure VPN Gateway costs for UK South',
          description: 'Use AzureCalc.uk to estimate monthly VPN Gateway costs in GBP.',
          step: [
            { '@type': 'HowToStep', position: 1, name: 'Select a SKU', text: 'Choose from Basic (legacy), VpnGw1–5, or zone-redundant AZ variants depending on throughput and availability requirements.' },
            { '@type': 'HowToStep', position: 2, name: 'Enter monthly outbound data', text: 'Input the GB you expect to send from Azure over the VPN each month. Inbound is free.' },
            { '@type': 'HowToStep', position: 3, name: 'Review the cost breakdown', text: 'The calculator shows gateway fee, egress charges, and the AZ premium comparison.' },
          ],
        })}</script>
        <script type="application/ld+json">{JSON.stringify(generateBreadcrumbList([
          { name: 'Home', url: '/', position: 1 },
          { name: 'VPN Gateway Calculator', url: '/vpn-gateway', position: 2 },
        ]))}</script>
      </Helmet>

      <div className="pb-6 mb-8" style={{ borderBottom: '1px solid var(--outline-variant)' }}>
        <Breadcrumbs />
        <h1 className="text-2xl font-bold mb-2" style={{ color: 'var(--text-primary)' }}>Azure VPN Gateway Cost Calculator</h1>
        <p className="text-sm" style={{ color: 'var(--text-tertiary)' }}>UK South pricing · Basic, VpnGw1–5, zone-redundant AZ SKUs · Site-to-site & P2S tunnels · Egress</p>
      </div>

      <VpnGatewayCalc />
    </div>
  )
}
